import { Meilisearch } from 'meilisearch';
import connectConfigure from 'instantsearch.js/es/connectors/configure/connectConfigure';

const inputTemplate = `
    <div class="geohash-widget">
        <div class="geohash-widget__zip-container me-2">
            <label class="geohash-widget__label form-label" for="geohash-zip">Postleitzahl-Suche</label>
            <input type="text" class="geohash-widget__zip-input form-control" name="geohash-zip" id="geohash-zip" placeholder="z.B. 53177" inputmode="numeric" maxlength="5" autocomplete="postal-code" aria-describedby="geohash-zip-error">
            <div id="geohash-zip-error" class="visually-hidden" aria-live="polite"></div>
        </div>
        <div class="geohash-widget__radius-container d-none">
            <label class="geohash-widget__label form-label" for="geohash-radius">Umkreis</label>
            <select class="geohash-widget__radius-input form-select" name="geohash-radius" id="geohash-radius">
                <option value="4" selected>ca. 20 km</option>
                <option value="3">ca. 80 km</option>
            </select>
        </div>
    </div>
`;

const geohashWidgetRender = ({ refine, widgetParams }, isFirstRender) => {
    const container = document.querySelector(widgetParams.container);
    if (isFirstRender) {
        container.innerHTML = inputTemplate;
    }
    const zipInput = container.querySelector('[name="geohash-zip"]');
    const radiusSelect = container.querySelector('[name="geohash-radius"]');
    const radiusContainer = container.querySelector('.geohash-widget__radius-container');
    const errorElement = container.querySelector('#geohash-zip-error');

    const setError = message => {
        errorElement.textContent = message;
        zipInput.setAttribute('aria-invalid', 'true');
        zipInput.setAttribute('aria-errormessage', 'geohash-zip-error');
        zipInput.setCustomValidity(message);
        zipInput.reportValidity();
    };
    const clearError = () => {
        errorElement.textContent = '';
        zipInput.removeAttribute('aria-invalid');
        zipInput.removeAttribute('aria-errormessage');
        zipInput.setCustomValidity('');
    };

    if (isFirstRender) {
        // initialize meilisearch client & geocoding index
        const meilisearch = new Meilisearch({
            host: widgetParams.url,
            apiKey: widgetParams.apiKey,
        });
        const geohashIndex = meilisearch.index('geocoding');

        const getGeohashesByZip = async zip => {
            const result = await geohashIndex.search(``, { filter: `zip = ${zip}` });
            return result.hits;
        };

        const displayValid = () => {
            zipInput.classList.add('is-valid');
            zipInput.classList.remove('is-invalid');
            clearError();
            radiusContainer.classList.remove('d-none');
        };
        const displayInvalid = message => {
            zipInput.classList.remove('is-valid');
            zipInput.classList.add('is-invalid');
            setError(message);
            radiusContainer.classList.add('d-none');
        };
        const resetValidityDisplay = () => {
            zipInput.classList.remove('is-valid');
            zipInput.classList.remove('is-invalid');
            clearError();
            radiusContainer.classList.add('d-none');
        };

        const refreshSearchResults = async () => {
            const zip = zipInput.value;
            const precision = Number(radiusSelect.value);
            if (isNaN(zip)) {
                displayInvalid('Bitte geben Sie eine Postleitzahl ein');
                return;
            }
            if (zip.length < 5) {
                resetValidityDisplay();
                refine({ facetFilters: [] });
                return;
            }
            const results = await getGeohashesByZip(zip);
            if (results.length) {
                const { geohash } = results[0];
                refine({ filters: `geohash_${precision} = ${geohash.substring(0, precision)}` });
                displayValid();
            } else {
                displayInvalid('Die eingegebene Postleitzahl existiert nicht');
            }
        };

        zipInput.addEventListener('input', refreshSearchResults);
        radiusSelect.addEventListener('input', refreshSearchResults);
    }
};

export const geohashWidget = connectConfigure(geohashWidgetRender);
